import BlogsComponents from "../components/BlogsComponents";

function Blog() {
  return (
    <>
      <BlogsComponents />
    </>
  );
}

export default Blog;
